<template>
  <div class="job-listings-container">
    <button class="job-listings-button" @click.prevent="goToJobListings">
      求人一覧を見る
    </button>
    <p class="job-listings-text">各社の求人検索やスカウト希望ができます</p>
  </div>
</template>

<script>
export default {
  name: "ScoutProfile",
  methods: {
    goToJobListings() {
      this.$router.push("/job-listings");
    },
  },
};
</script>

<style scoped>
.job-listings-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px 0px 0px 10px;
}

.job-listings-button {
  background-color: white;
  color: black;
  border: 1px solid black;
  border-radius: 4px;
  padding: 10px 20px;
  width: 233px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.job-listings-button:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.job-listings-text {
  margin-top: 10px;
  font-size: 10px;
  color: #333;
  text-align: center;
}
</style>
